module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BEaDJ/media/FC-9781398482159.jpg?1689450778561",
      "alt": "This image is the cover for the book Prunes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Prunes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Old spies don’t retire, they just sit on the sidelines until needed. This is what Mr Eggington and Violet believed until they uncovered a plot that would reshape the financial world. Mr Eggington was counting toilet rolls and paperclips until he reached retirement, and his best former operative, Violet, had ended up as a tea lady. Events unfold with surprising speed after she tries to buy a packet of biscuits to go home with Mr Eggington’s tea. She is set up and ‘roofied’ ending up in an old person’s home after this dastardly attack and Mr Eggington is ridiculed when he tried to bring his fears to the attention of his boss. Rallying the most unlikely people they engineer a plot to save the country. Hidden depths are uncovered in their new friends and they pool all their skills to overthrow the evil megalomaniac, after trying to break all the codes and riddles of course!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pat Daniel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The author was born, raised and currently lives in the West Midlands. After studying psychology and having a keen interest in family history and ancestry, she enjoys delving into peoples backstories, researching and bringing them to life.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0